import { useMemo } from 'react'

import { TeamsSelectorDocument, type TeamsSelectorQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export interface TeamOption {
  label: string
  value: string
}

export const useTeams = (): {
  teams: TeamOption[]
  loading: boolean
  error?: unknown
} => {
  const { data, loading, error } = useQuery<TeamsSelectorQuery, Record<string, never>>(
    TeamsSelectorDocument,
    {
      fetchPolicy: 'cache-and-network',
    },
  )

  const nodes = useMemo<
    NonNullable<
      NonNullable<TeamsSelectorQuery['teams']>['teamsConnection']['edges'][number]
    >['node'][]
  >(
    () => (data?.teams?.teamsConnection?.edges ?? []).map((edge) => edge.node),
    [data?.teams?.teamsConnection?.edges],
  )

  const teams = useMemo<TeamOption[]>(() => {
    return nodes
      .filter((node): node is NonNullable<(typeof nodes)[number]> => Boolean(node))
      .map((node) => ({
        label: node.name ?? '',
        value: node.id,
      }))
  }, [nodes])

  return { teams, loading, error }
}
